import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();
  return (
    <div className="flex-grow-1">
      <div className="app-body bg-light-gradient">
        <div className="container my-3">
          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-6 mb-5">
              <h1 className="my-3">{t("about.description.title")}</h1>
              <p className="mb-0">{t("about.description.body")}</p>
            </div>
            <div className="col-12 col-md-6">
              <img className="rounded-4 bg-light" src="/assets/about-us/aufbau_aesch.jpg" alt="Bild Drehort"/>
              <p className="small text-center mt-1 mb-0">{t("about.description.image_caption")}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="app-body bg-black text-center">
        <div className="container py-5">
          <div className="row text-light">
            <div className="col-12 col-md-4">
              <i className="bi bi-camera text-primary" style={{ fontSize: '5rem' }}/>
              <h4 className="text-white">{t("about.equipment.camera.title")}</h4>
              <p className="opacity-75">{t("about.equipment.camera.body")}</p>
            </div>
            <div className="col-12 col-md-4">
              <i className="bi bi-mic text-primary" style={{ fontSize: '5rem' }}/>
              <h4 className="text-white">{t("about.equipment.microphone.title")}</h4>
              <p className="opacity-75">{t("about.equipment.microphone.body")}</p>
            </div>
            <div className="col-12 col-md-4">
              <i className="bi bi-laptop text-primary" style={{ fontSize: '5rem' }}/>
              <h4 className="text-white">{t("about.equipment.software.title")}</h4>
              <p className="opacity-75">{t("about.equipment.software.body")}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="app-body bg-light-gradient text-center">
        <div className="container my-3">
          <div className="row d-flex align-items-center">
            <div className="d-none d-md-block col-md-4">
              <img className="rounded-4 object-fit-cover bg-light" src="/assets/about-us/hall_of_fame.jpeg"
                   alt="Bild Drehort"
                   style={{ aspectRatio: 3/4 }}/>
              <p className="small text-center mt-1 mb-0">{t("about.support.image_caption")}</p>
            </div>
            <div className="col-12 col-md-8 mb-3">
              <h2>{t("about.support.title")}</h2>
              <p className="mb-0">{t("about.support.body")}</p>
              <Link to="/contact" className="link-dark">{t("about.support.contact_link")}</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}